/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconAdminSearch = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--adminsearch',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><path className="path1" fillRule="evenodd" clip-rule="evenodd" d="M11.71 11h.79l4.99 5L16 17.49l-5-4.99v-.79l-.27-.28A6.471 6.471 0 0 1 6.5 13 6.5 6.5 0 1 1 13 6.5c0 1.61-.59 3.09-1.57 4.23l.28.27zM2 6.5C2 8.99 4.01 11 6.5 11S11 8.99 11 6.5 8.99 2 6.5 2 2 4.01 2 6.5z" fill="#BDBDBD"/></IconBase>
  )
}

IconAdminSearch.propTypes = {
  className: PropTypes.string,
}

export default IconAdminSearch
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconAdminSearch.js